/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Revokesessionfailed3Inputs */

const zh_accountsettings_revokesessionfailed3 = /** @type {(inputs: Accountsettings_Revokesessionfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注销会话失败`)
};

const en_accountsettings_revokesessionfailed3 = /** @type {(inputs: Accountsettings_Revokesessionfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to revoke session`)
};

const es_accountsettings_revokesessionfailed3 = /** @type {(inputs: Accountsettings_Revokesessionfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al revocar la sesión`)
};

/**
* | output |
* | --- |
* | "Failed to revoke session" |
*
* @param {Accountsettings_Revokesessionfailed3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_revokesessionfailed3 = /** @type {((inputs?: Accountsettings_Revokesessionfailed3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Revokesessionfailed3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_revokesessionfailed3(inputs)
	if (locale === "en") return en_accountsettings_revokesessionfailed3(inputs)
	return es_accountsettings_revokesessionfailed3(inputs)
});
export { accountsettings_revokesessionfailed3 as "accountSettings_revokeSessionFailed" }